import { Component, OnInit, Input, AfterViewInit, OnChanges, SimpleChanges, LOCALE_ID, Inject } from '@angular/core';
import 'parse';
import { Moment } from 'moment';
import { Report } from '../../model/report.model';
import { MonitorStatus } from '../../model/monitoring.model';
import { MonitoringService } from '../../service/monitoring.service';
import { FormControl, FormGroup } from '@angular/forms';
import { ToastService } from '../../service/toast.service';
import { ReportService } from '../../service/report.service';
const parse: typeof Parse = require('parse');

@Component({
  selector: 'app-report-details',
  templateUrl: './report-details.component.html',
  styleUrls: ['./report-details.component.less']
})
export class ReportDetailsComponent{
  notesForm: FormGroup;
  timerEvent: NodeJS.Timer;
  moment = require('moment/moment');
  @Input() report: Report;
  reportCreatedAt: Moment;
  tchekCreatedAt: Moment;
  monitor: MonitorStatus;
  location: string;
  lang: any;

  constructor(
    @Inject(LOCALE_ID) protected localeId: string,
    private readonly _monitoringService: MonitoringService, 
    private readonly _toastService: ToastService,
    private readonly _reportService: ReportService,
    ) {
      this.notesForm = new FormGroup({
        notes: new FormControl(''),
      });
    this.lang = localeId;
  }

  saveChanges(): void {
    this.moment.locale(this.lang);
    if (this.report) {
      if (this.report.reportCreatedAt)
        this.reportCreatedAt = this.moment(this.report.reportCreatedAt).format("dddd D MMMM YYYY HH:mm:ss");
      if (this.report.tchekPtr.tchekCreatedAt)
        this.tchekCreatedAt = this.moment(this.report.tchekPtr.tchekCreatedAt).format("dddd D MMMM YYYY HH:mm:ss");
      if (this.report.tchekPtr.devicePtr.gpsLocation)
        this.location = this.report.tchekPtr.devicePtr.gpsLocation;
      this.sendData();
    }
  }

  sendData() {
    clearTimeout(this.timerEvent);
    this.timerEvent = setTimeout(() => {
      this._toastService.toastOpen(true);
      this._reportService.save(this.report).then(() => {
        this._toastService.toastOpen(false);
      });
    }, 500);
  }

}

/*
  scanDate : Date; ok tchek ct at
  timestamp : Date; -> tck ct at
  gps : String; aj dans device
      */


// WEBPACK FOOTER //
// ./src/app/element/report-details/report-details.component.ts